var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateEpisodeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3091_68)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.84C0 1.18314 1.34315 -0.160004 3 -0.160004H13C14.6569 -0.160004 16 1.18314 16 2.84V20.84C16 22.4969 14.6569 23.84 13 23.84H3C1.34315 23.84 0 22.4969 0 20.84V2.84ZM3 1.84C2.44771 1.84 2 2.28771 2 2.84V20.84C2 21.3923 2.44772 21.84 3 21.84H13C13.5523 21.84 14 21.3923 14 20.84V2.84C14 2.28771 13.5523 1.84 13 1.84H3Z",
    fill: "#6C74B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8271 23.84H21C22.6568 23.84 24 22.4969 24 20.84V2.84C24 1.18314 22.6568 -0.160004 21 -0.160004H19.3092C20.1208 0.241615 20.7336 0.966748 20.9667 1.84H21C21.5523 1.84 22 2.28771 22 2.84V20.84C22 21.3809 21.5705 21.8215 21.0339 21.8394C20.9094 22.6496 20.464 23.3582 19.8271 23.84Z",
    fill: "#6C74B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.818 23.84H16.9908C18.6477 23.84 19.9908 22.4969 19.9908 20.84V2.84C19.9908 1.18314 18.6477 -0.160004 16.9908 -0.160004H15.3C16.1116 0.241615 16.7244 0.966748 16.9575 1.84H16.9908C17.5431 1.84 17.9908 2.28771 17.9908 2.84V20.84C17.9908 21.3809 17.5613 21.8215 17.0247 21.8394C16.9002 22.6496 16.4549 23.3582 15.818 23.84Z",
    fill: "#6C74B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.84C12 12.3923 11.5523 12.84 11 12.84H5C4.44772 12.84 4 12.3923 4 11.84C4 11.2877 4.44772 10.84 5 10.84H11C11.5523 10.84 12 11.2877 12 11.84Z",
    fill: "#6C74B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.84C12 12.3923 11.5523 12.84 11 12.84H5C4.44772 12.84 4 12.3923 4 11.84C4 11.2877 4.44772 10.84 5 10.84H11C11.5523 10.84 12 11.2877 12 11.84Z",
    fill: "#6C74B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.84C12 12.3923 11.5523 12.84 11 12.84H5C4.44772 12.84 4 12.3923 4 11.84C4 11.2877 4.44772 10.84 5 10.84H11C11.5523 10.84 12 11.2877 12 11.84Z",
    fill: "#6C74B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15.84C7.44772 15.84 7 15.3923 7 14.84L7 8.84C7 8.28771 7.44772 7.84 8 7.84C8.55229 7.84 9 8.28771 9 8.84L9 14.84C9 15.3923 8.55228 15.84 8 15.84Z",
    fill: "#6C74B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15.84C7.44772 15.84 7 15.3923 7 14.84L7 8.84C7 8.28771 7.44772 7.84 8 7.84C8.55229 7.84 9 8.28771 9 8.84L9 14.84C9 15.3923 8.55228 15.84 8 15.84Z",
    fill: "#6C74B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15.84C7.44772 15.84 7 15.3923 7 14.84L7 8.84C7 8.28771 7.44772 7.84 8 7.84C8.55229 7.84 9 8.28771 9 8.84L9 14.84C9 15.3923 8.55228 15.84 8 15.84Z",
    fill: "#6C74B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3091_68"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateEpisodeIcon);
export default __webpack_public_path__ + "static/media/create-episode-icon.b27a1a6f0aacc668e713fc1ce784988d.svg";
export { ForwardRef as ReactComponent };